export type ElectricSession = {
  id: string;
  title: string | null;
  kind: string;
  config: Record<string, unknown>;
  created_at: string;
  updated_at: string;
  status: string;
  owned_by_space_account_id: string;
  accessible_by_space_account_ids: string[];
  config_json: Record<string, unknown>;
  description: string | null;
  locally_created_at: string;
  processing_scheduled_for: string | null;
};

export type ElectricSessionEvent = {
  id: string;
  session_id: string;
  created_at: string;
  updated_at: string;
  accessible_by_space_account_ids: string[];
  event_kind: string;
  locally_created_at: string;
  value_json: Record<string, unknown>;
  owner_space_account_id: string;
};

export interface SessionEventsState {
  // Subscription state
  isSubscribed: boolean;
  subscriptionError: string | null;

  // Session data
  sessionData: ElectricSession | null;
  sessionEvents: ElectricSessionEvent[];

  // Loading states
  isSessionLoading: boolean;
  isEventsLoading: boolean;

  // Current session ID
  sessionId: string | null;
}

export enum SessionEventsAction {
  SUBSCRIBE_REQUEST = "SUBSCRIBE_REQUEST",
  SUBSCRIBE_SUCCESS = "SUBSCRIBE_SUCCESS",
  SUBSCRIBE_ERROR = "SUBSCRIBE_ERROR",
  SESSION_DATA_UPDATED = "SESSION_DATA_UPDATED",
  SESSION_EVENTS_UPDATED = "SESSION_EVENTS_UPDATED",
  UNSUBSCRIBE = "UNSUBSCRIBE",
  SET_SESSION_ID = "SET_SESSION_ID",
}

export type SessionEventsActionType =
  | { type: SessionEventsAction.SUBSCRIBE_REQUEST; payload: { sessionId: string } }
  | { type: SessionEventsAction.SUBSCRIBE_SUCCESS }
  | { type: SessionEventsAction.SUBSCRIBE_ERROR; payload: { error: string } }
  | { type: SessionEventsAction.SESSION_DATA_UPDATED; payload: { sessionData: ElectricSession } }
  | {
      type: SessionEventsAction.SESSION_EVENTS_UPDATED;
      payload: { events: ElectricSessionEvent[] };
    }
  | { type: SessionEventsAction.UNSUBSCRIBE }
  | { type: SessionEventsAction.SET_SESSION_ID; payload: { sessionId: string } };

export interface SessionEventsContextValue extends SessionEventsState {
  // Actions
  subscribeToSession: (sessionId: string) => Promise<void>;
  unsubscribeFromSession: () => void;

  // Computed values
  sortedEvents: ElectricSessionEvent[];
  isReady: boolean;
}
